import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'

const ThumbsUpOrange: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component="svg"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 54 54"
    fill="none"
    {...props}
  >
    <path
      d="M48.9218 30.8531C49.0129 29.1038 47.6224 27.657 45.8933 27.657H44.7064C46.4355 27.657 47.8271 26.2103 47.7349 24.4609C47.6494 22.8206 46.1768 21.591 44.5343 21.591C44.5343 21.591 37.5075 21.591 37.5075 21.5843H31.9129L32.5755 19.5975C33.3754 17.199 33.6521 14.553 33.2595 12.024C32.9726 10.179 32.1548 8.14502 29.9756 8.14502C28.4951 8.14502 27.2284 9.21039 26.9753 10.6695C26.145 15.4429 23.355 20.3445 19.9969 23.7949C19.0991 24.7174 18.5963 25.9538 18.5963 27.2419V27.6435V28.8821V39.9735C18.5963 42.0953 19.8169 44.0516 21.7541 44.9168C23.1064 45.5209 24.6026 45.8573 26.1799 45.8573H42.4553C44.0978 45.8573 45.5704 44.6276 45.6559 42.9874C45.747 41.238 44.3565 39.7913 42.6274 39.7913H44.208C45.8505 39.7913 47.3231 38.5616 47.4086 36.9214C47.4998 35.172 46.1093 33.7253 44.3801 33.7253H45.7256C47.3636 33.723 48.8363 32.4934 48.9218 30.8531Z"
      fill="#FF612B"
    />
    <path
      d="M18.8786 22.7003H5.06586V45.8562H18.8786V22.7003Z"
      fill="#3D3C38"
    />
  </Box>
)

export default ThumbsUpOrange
